import { useQuery } from '@tanstack/react-query';
import { Pose } from '../models';
import QueryKeys from '../utils/QueryKeys';

/**
 * EVERY photo the student was shot in this package's season(s), in the photographer's
 * favorite order — the set the senior gallery must show.
 *
 * usePoses() filters through Pose.for_package, which ends in `.where(number:
 * pose_numbers)` — the pose numbers the PRICELIST configures. Frames numbered above
 * that list are silently invisible to the customer. For a viewing/selection surface
 * that is the wrong question; this asks the complete-set one instead
 * (Pose.all_images_for_buy_all, via the complete_for_package filter).
 *
 * The purchase/build steps still use usePoses: there, pricelist config genuinely is
 * the right filter, because each pose slot carries its layout (background, position).
 */
export default function useAllSeniorPoses(studentId, packageId) {
  return useQuery(
    [QueryKeys.STUDENT_IMAGES, 'complete', studentId, packageId],
    () => Pose
      .where({ completeForPackage: [packageId, studentId] })
      .per(999)
      .all()
      .then((res) => res.data || []),
    { placeholderData: [], enabled: !!(studentId && packageId) },
  );
}
